import * as React from 'react';

// Components
import LoadingIndicator from '../LoadingIndicator';

import styles from './style.scss';

export default function PageLoading(): JSX.Element {
  return <LoadingIndicator className={styles.container} />;
}
